import http from "../../http-common";

const addNewUserToDomain = (domainId, newUser) => {
  return http.post(`/api/auth/new/${domainId}`, newUser);
};

const deleteUserByEmailAndDomain = (domainId, emailAndToken) => {
  return http.post(`/api/auth/remove/${domainId}`, emailAndToken);
};

const refreshUser = (userId) => {
  return http.get(`users/${userId}/refreshData`);
};

const UserService = {
  addNewUserToDomain,
  deleteUserByEmailAndDomain,
  refreshUser,
};

export default UserService;
